import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DelegationService } from 'src/app/shared/services/delegation.service';
import {map, tap} from 'rxjs/operators';
import { Delegation } from 'src/app/shared/models/delegation.model';
import { TableDataSource } from 'src/app/shared/components/table/table-data-source';
import { tableSortFn } from 'src/app/shared/utils/sort.util';
import {CostStatuses} from '../../../shared/models/cost.model';
import {ConfirmService} from '../../../shared/services/confirm.service';
import {CostService} from '../../../shared/services/cost.service';
import {ToastrService} from 'ngx-toastr';
import {Redirect} from '../../../shared/utils/redirect.util';
import {EmployeeService} from '../../../shared/services/employee.service';
import {Employee} from '../../../shared/models/employee.model';

@Component({
  selector: 'app-delegations-employees',
  templateUrl: './delegations-employees.component.html'
})
export class DelegationsEmployeesComponent implements OnInit {
  readonly delegationStatuses = CostStatuses;
  delegations: Delegation[];
  delegations$;
  employees$;
  dataSource = new TableDataSource<Delegation>();
  displayedColumns: string[] = ['employee.person.lastName', 'delegationNumber', 'status.name', 'createdAt', 'advance.name', 'grossValue', 'forwardedToPaymentAt', 'returnedAt', 'action'];

  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private serviceDelegation: DelegationService,
    private confirmService: ConfirmService,
    private costService: CostService,
    private toastrService: ToastrService,
    private redirect: Redirect,
    private employeeService: EmployeeService,
  ) { }

  ngOnInit() {
    this.delegations$ = this.serviceDelegation.fetchDelegations()
      .pipe(
        map((delegations: Delegation[]) => {
          this.delegations = this.dataSource.data = delegations;
          this.dataSource.sortingDataAccessor = tableSortFn;
          return delegations;
        })
      );

    this.employees$ = this.employeeService.activeEmployees$;
  }

  removeDelegation(cost: any) {
    if (cost.canRemove) {
      this.confirmService.openConfirmDialog('Czy na pewno chcesz usunąć delegację? Zmiana będzie nieodwracalna.')
        .afterClosed().subscribe(confirm => {
        if (confirm) {
          this.costService.removeCost(cost.id).subscribe(res => {
            this.toastrService.success('Delegacja została usunięta.');
            this.redirect.to();
          }, _ => this.toastrService.error('Delegacja nie może zostać usunięta.'));
        }
      });
    }
  }

  onSelectEmployee(employee: Employee) {
    if (employee) {
      this.dataSource.data = this.delegations.filter((delegation: any) => delegation.employee.id === employee.id);
      return;
    }
    this.dataSource.data = this.delegations;
  }
}
